import { from } from 'rxjs';
import { filter } from 'rxjs/operators';
// import * as Actions from '@shoflo/studio-redux/actions/types';
// import * as Types from '@shoflo/studio-redux/constants/SocketEvents';

/**
 * Target specific actions for emitting notifying socket events
 *
 * This should be used instead of calling socket.emit(''', {notifyingDirector})
 * directly inside of actions
 *
 * NOTE!!!
 * MAKE SURE THAT YOU ONLY EMIT EVENTS THAT CANNOT BE EMITTED BY THE
 * notifyDirectors INSIDE @shoflo/studio-redux (REDUX). EVERY TIME
 * TO EMIT AN EVENT ASK YOURSELF IF IT IS ALREADY BEING EMITTED
 * FROM REDUX OR IF IT CAN BE EMITTED FROM REDUX. THE PRIORITY
 * IS TO EMIT THE EVENTS FROM REDUX FOR REUSABILITY.
 *
 * @param {{ emit: Function }} socket
 */
function notifyDirectors(socket) {
  return (store) => (next) => async (action) => {
    // todo uncomment all commented code and remove all instances of
    //  eslint-disable-*
    const targetedActions = [
      // Types.SOME_ACTION_TYPE
    ];

    from([action])
      .pipe(filter(($action) => targetedActions.includes($action.type)))
      .subscribe(async ($action) => {
        const {
          broadcast,
          meeting: { attendeeResponse },
        } = store.getState();

        const broadcastId = broadcast?._id;
        const notifyingDirector = attendeeResponse?.Attendee.AttendeeId;

        // eslint-disable-next-line no-unused-vars
        const { type, payload } = $action;

        // eslint-disable-next-line no-unused-vars
        function emitSocketEvent(socketEvent, payload) {
          socket.emit(socketEvent, {
            broadcastId,
            notifyingDirector,
            ...payload,
          });
        }

        // switch (type) {
        //   case Types.SOME_ACTION_TYPE: {
        //     emitSocketEvent(Events.SOME_SOCKET_EVENT, payload);
        //     break;
        //   }
        // }
      });

    return next(action);
  };
}

export default notifyDirectors;
